import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SepidzGridModule } from "projects/sepidz-web-framework-data-grid/src/lib/grid.module";
import { SharedModule } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { ReportReviewModule } from "src/app/review/review.module";
import { AccBalance4Component } from "./aa-balce4/acc-balance-4.component";
import { AccBalance6Component } from "./aa-balce6/acc-balance-6.component";
import { AccBalance8Component } from "./aa-balce8/acc-balance-8.component";
import { AccBalanceSheetCompareWithPrevYearGeneralLedgerFilterdByDetailLedgerComponent } from "./balance-sheet-compare-prev-year-generalledger-filterd-by-detailLedger/balance-sheet-compare-prev-year-generalledger-filterd-by-detailLedger.component";
import { AccBalanceSheetCompareWithPrevYearSubLedgerFilterdByDetailLedgerComponent } from "./balance-sheet-compare-prev-year-subledger-filterd-by-detailLedger/balance-sheet-compare-prev-year-subledger-filterd-by-detailLedger.component";
import { AccBalanceSheetCompareWithPrevYearComponent } from "./balance-sheet-compare-with-prev-year/balance-sheet-compare-with-prev-year.component";
import { AccBalanceSheetComponent } from "./balance-sheet/acc-balance-sheet.component";
import { AccDetailLedegerSubledgerBalancSheetComponent } from "./detail-ledeger-subledger-balanc-sheet/detail-ledeger-subledger-balanc-sheet.component";
import { GeneralLedgerDailyVoucherComponent } from "./general-ledger-daily-voucher/general-ledger-daily-voucher.component";
import { GeneralLedgerVoucherComponent } from "./general-ledger-voucher/general-ledger-voucher.component";
import { GeneralLedgerVoucherDocumentComponent } from "./general-ledger-voucher-document/general-ledger-voucher-document.component";
import { GeneralLedgerDailyVoucherDocumentComponent } from "./general-ledger-daily-voucher-document/general-ledger-daily-voucher-document.component";

const components = [
  AccBalanceSheetComponent,
  AccBalance4Component,
  AccBalance6Component,
  AccBalance8Component,
  AccDetailLedegerSubledgerBalancSheetComponent,
  AccBalanceSheetCompareWithPrevYearComponent,
  AccBalanceSheetCompareWithPrevYearGeneralLedgerFilterdByDetailLedgerComponent,
  AccBalanceSheetCompareWithPrevYearSubLedgerFilterdByDetailLedgerComponent,
  GeneralLedgerVoucherComponent,
  GeneralLedgerVoucherDocumentComponent,
  GeneralLedgerDailyVoucherComponent,
  GeneralLedgerDailyVoucherDocumentComponent,
];
@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, FormsModule, SharedModule.forRoot(), SepidzGridModule, ReportReviewModule],
})
export class AccountReportModule {}
